// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__yBHfZ","row":"Node_row__2uTrQ","label":"Node_label__3BL2M","footer":"Node_footer__oJPr-"};